import React, { useEffect } from 'react';
import CalendarioWidget from './CalendarioWidget';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { useUsers } from '../../../metodos/userContext';
import { useNavigate } from 'react-router-dom';

const CalendarioPage = () => {
  const {
    servicios,
    loadingServicios,
    errorServicios,
    cargarServicios,
  } = useContabilidadModel();
  const navigate = useNavigate();
  const { usuario, loadingUsuario, errorUsuario } = useUsers();
  
  // Efecto para cargar servicios al montar el componente
  useEffect(() => {
    if (usuario && usuario.nombrewhatsapp) {
        cargarServicios(usuario.nombrewhatsapp,false);
    }
    }, [usuario]); 
  
  // Si está cargando, mostrar un indicador de carga
  if (loadingServicios || loadingUsuario) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  // Si hay un error, mostrar mensaje de error
  if (errorServicios || errorUsuario) {
    return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
        <strong className="font-bold">Error: </strong>
        <span className="block sm:inline">
          {errorServicios || errorUsuario || "Ocurrió un error al cargar los datos"}
        </span>
      </div>
    );
  }

  const servicioClick = (servicio) => {
    if(servicio.tipo == "servicioPrincipal"){
      navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
    } else{
      const idEntregaCodificado = encodeURIComponent(servicio.identificador);
      navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}/entregasParciales/${idEntregaCodificado}`);
    }
  }
  
  return (
    <div className="container mx-auto py-8">
      
      {/* Pasamos los servicios al componente de calendario */}
      <CalendarioWidget 
        servicios={servicios} 
        onServicioClick={servicioClick}
      />
      
      {/* Información adicional si no hay servicios */}
      {servicios && servicios.length === 0 && (
        <div className="mt-8 text-center">
          <p className="text-gray-700">
            No hay servicios agendados para mostrar en el calendario.
          </p>
          <p className="text-gray-500 mt-2">
            Los servicios aparecerán aquí una vez que se hayan asignado.
          </p>
        </div>
      )}
    </div>
  );
};

export default CalendarioPage;